<template>
    <div class="static-icon-preview-background">
        <eicon :kind="iconKind" />
    </div>
</template>

<script>
const elementTypeToEiconTypeMapping = {
    iframe: 'web',
    streaming: 'streaming-compact'
}

export default {
    props: {
        /** @type {PublishElementDataCommon} */
        data: Object
    },
    computed: {
        iconKind() {
            return elementTypeToEiconTypeMapping[this.data.type] ?? this.data.type
        }
    }
}
</script>

<style>
.static-icon-preview-background {
    background-color: #FBFBFB;

    display: flex;
    align-items: center;
    justify-content: center;

}

/* These styles specific to esign component structure as of writing.
   Added here instead of in eicon so backward compatibility is preserved. */
.static-icon-preview-background > div {
    height: 68%; /* 68% selected by augenmass, feels right */
    width: 68%;
}

.static-icon-preview-background > div > svg {
    height: 100%;
    width: 100%;
}
</style>
